import { render, staticRenderFns } from "./TableProductCustomers.vue?vue&type=template&id=11680214&"
import script from "./TableProductCustomers.vue?vue&type=script&lang=js&"
export * from "./TableProductCustomers.vue?vue&type=script&lang=js&"
import style0 from "./TableProductCustomers.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11680214')) {
      api.createRecord('11680214', component.options)
    } else {
      api.reload('11680214', component.options)
    }
    module.hot.accept("./TableProductCustomers.vue?vue&type=template&id=11680214&", function () {
      api.rerender('11680214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableProductCustomers.vue"
export default component.exports